/**
 * Soft, WCAG-AA–friendly colours (black text ≥ 4.5 : 1 contrast).
 * Source: hand-picked from Material & Tailwind “50/100” shades, then
 * verified with https://contrast-ratio.com.
 */
export const USER_COLORS = [
  "#FFD6CC", // peach-100
  "#FFE0B2", // apricot-100
  "#FFF59D", // banana-100
  "#D0F8CE", // mint-100
  "#B2EBF2", // aqua-100
  "#BBDEFB", // sky-100
  "#C5CAE9", // indigo-100
  "#E1BEE7", // lavender-100
  "#F8BBD0", // orchid-100
  "#FFCDD2", // rose-100
  "#B3E5FC", // ice-100
  "#F0F4C3" // lemon-100
] as const;

/** Pick one at random – no more punch-in-the-eyes colours */
export const randomColor = () => USER_COLORS[Math.floor(Math.random() * USER_COLORS.length)];
